{
  "$id": "wealthlane://forms/job-scheduler-recurrence/rules",
  "$schema": "wealthlane://schemas/form-rules",
  "rules": [
    {
      "id": "recurrenceRepeatEveryRequired",
      "target": "repeatEvery",
      "rule": "required",
      "message": "Required"
    },
    {
      "id": "recurrenceRepeatEveryMin",
      "target": "repeatEvery",
      "rule": "greaterThanOrEqual",
      "comparedTo": 1,
      "message": "Must be at least 1",
      "condition": { "field": "repeatEvery", "notEmpty": true }
    },
    {
      "id": "recurrenceRepeatUnitRequired",
      "target": "repeatUnit",
      "rule": "required",
      "message": "Required"
    },
    {
      "id": "recurrenceRepeatOnDaysMinItems",
      "target": "repeatOnDays",
      "rule": "arrayMinItems",
      "minValue": 1,
      "condition": { "field": "repeatUnit", "equals": "week" },
      "message": "Select at least one day"
    },
    {
      "id": "recurrenceEndTypeRequired",
      "target": "endType",
      "rule": "required",
      "message": "Required"
    },
    {
      "id": "recurrenceEndOnRequired",
      "target": "endOn",
      "rule": "required",
      "condition": { "field": "endType", "equals": "on" },
      "message": "End date is required"
    },
    {
      "id": "recurrenceOccurrencesLimitRequired",
      "target": "occurrencesLimit",
      "rule": "required",
      "condition": { "field": "endType", "equals": "after" },
      "message": "Number of occurrences is required"
    },
    {
      "id": "recurrenceOccurrencesLimitMin",
      "target": "occurrencesLimit",
      "rule": "greaterThanOrEqual",
      "comparedTo": 1,
      "message": "Must be at least 1",
      "condition": { "field": "endType", "equals": "after" }
    }
  ],
  "effects": [
    {
      "id": "clearRepeatOnDaysWhenNotWeek",
      "watch": ["repeatUnit"],
      "condition": { "field": "repeatUnit", "notEquals": "week" },
      "set": { "repeatOnDays": [] }
    },
    {
      "id": "defaultRepeatOnDaysForWeek",
      "watch": ["repeatUnit"],
      "condition": {
        "allOf": [
          { "field": "repeatUnit", "equals": "week" },
          { "field": "repeatOnDays", "isEmpty": true }
        ]
      },
      "set": { "repeatOnDays": ["MON"] }
    }
  ]
}
